export const renewableEnergy = {
  market: 'Market',
  optionsAvailable: 'Options available',
  pdf: 'PDF'
};
